"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactModal = _interopRequireDefault(require("react-modal"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var VideoModal = /*#__PURE__*/function (_React$PureComponent) {
  function VideoModal() {
    (0, _classCallCheck2["default"])(this, VideoModal);
    return _callSuper(this, VideoModal, arguments);
  }
  (0, _inherits2["default"])(VideoModal, _React$PureComponent);
  return (0, _createClass2["default"])(VideoModal, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        closeModal = _this$props.closeModal,
        title = _this$props.title,
        video = _this$props.video;
      var embedUrl = video;
      if (embedUrl && embedUrl.includes('https://vimeo.com')) {
        embedUrl = embedUrl.replace('vimeo.com/', 'player.vimeo.com/video/');
        embedUrl += '?autoplay=1';
      }
      return /*#__PURE__*/_react["default"].createElement(_reactModal["default"], {
        closeTimeoutMS: 10,
        isOpen: true,
        onRequestClose: closeModal,
        ariaHideApp: false,
        className: "video-modal-content"
      }, /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "modal-close",
        onClick: closeModal
      }, "Close"), /*#__PURE__*/_react["default"].createElement("div", {
        className: "video-modal-player"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "aspect-10-4"
      }, embedUrl && /*#__PURE__*/_react["default"].createElement("iframe", {
        style: {
          width: '100%'
        },
        title: title,
        src: embedUrl,
        frameBorder: "0",
        allow: "autoplay; encrypted-media",
        allowFullScreen: "true",
        webkitallowfullscreen: "true",
        mozallowfullscreen: "true"
      }))));
    }
  }]);
}(_react["default"].PureComponent);
VideoModal.propTypes = {
  closeModal: _propTypes["default"].func.isRequired,
  title: _propTypes["default"].string,
  video: _propTypes["default"].string
};
var _default = exports["default"] = VideoModal;